/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ConfigService } from './config.service'
import { CustomTranslateLoader } from './CustomTranslateLoader'

export function HttpLoaderFactory(): CustomTranslateLoader {
  return new CustomTranslateLoader(inject(HttpClient), inject(ConfigService))
}
